/**
 * Lightweight logger — silent in production, verbose in development.
 * Swap in Sentry / Datadog later without touching call sites.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args); },
  info:  (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default logger;
